import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import confetti from "canvas-confetti";

const StreakContext = createContext({
  streak: null,
  pingStudy: () => Promise.resolve(),
  refresh: () => {},
});

export function useStreak() {
  return useContext(StreakContext);
}

function fireConfetti(color) {
  const defaults = { spread: 90, ticks: 100, gravity: 0.9, decay: 0.94, startVelocity: 32 };
  // Two bursts from left + right
  confetti({ ...defaults, particleCount: 60, origin: { x: 0.15, y: 0.75 }, colors: [color, "#ffffff", "#fde68a"] });
  confetti({ ...defaults, particleCount: 60, origin: { x: 0.85, y: 0.75 }, colors: [color, "#ffffff", "#fde68a"] });
  setTimeout(() => {
    confetti({ ...defaults, particleCount: 40, origin: { x: 0.5, y: 0.55 }, colors: [color, "#fff"] });
  }, 250);
}

export function StreakProvider({ children }) {
  const [streak, setStreak] = useState(null);

  const refresh = useCallback(() => {
    api.get("/study/streak").then((r) => setStreak(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const pingStudy = useCallback(async () => {
    try {
      const r = await api.post("/study/log");
      const { newly_earned_tier, current_streak, tier } = r.data;
      // Optimistic streak refresh
      setStreak((s) => (s ? { ...s, current_streak, tier } : s));
      if (newly_earned_tier) {
        fireConfetti(newly_earned_tier.color || "#f59e0b");
        toast.success(
          `${newly_earned_tier.emoji}  ${newly_earned_tier.name} unlocked!`,
          {
            description: `You've studied ${current_streak} days in a row. Keep the streak alive!`,
            duration: 6000,
          },
        );
      }
      return r.data;
    } catch (e) {
      // silent — streak ping is best-effort
      return null;
    }
  }, []);

  return (
    <StreakContext.Provider value={{ streak, pingStudy, refresh }}>
      {children}
    </StreakContext.Provider>
  );
}
